// extracted by mini-css-extract-plugin
export default {"link":"G712663"};